import * as DialogsService from './DialogsService';
import { addDialog, closeAllDialogs, closeDialog } from './DialogsService';
import type { DialogPropMap, DialogProps, StoredDialog } from './types';
import { Dialog } from './types';

export { addDialog, closeAllDialogs, closeDialog, DialogPropMap, Dialog, DialogProps, StoredDialog };
export default DialogsService;
